import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { DropdownItem, Input } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { RootStoreContext } from "../../app/stores/rootStore";

const MainNavBarAutoOnAirCheckbox = () => {
  const rootStore = useContext(RootStoreContext);
  const { autoOnairOnSharing, setAutoOnairOnSharing } = rootStore.screensStore;
  const [t] = useTranslation(["translation"], translationHookOptions);
  
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAutoOnairOnSharing(e.target.checked);
  };

  return (
    <>
      <DropdownItem>
        <div className="custom-control custom-checkbox">
          <Input
            type="checkbox"
            id="cb_autoonair"
            className="custom-control-input"
            checked={autoOnairOnSharing}
            onChange={handleCheckboxChange}
          />
          <label
            className="custom-control-label text-nowrap"
            htmlFor="cb_autoonair"
            style={{fontSize:"14px"}}
          >
            {t("navbar_dropdown_autoonair")}
          </label>
        </div>
      </DropdownItem>
      <DropdownItem divider />
    </>
  );
};

export default observer(MainNavBarAutoOnAirCheckbox);
